import React from 'react';
import { H2Alt, SecondaryH6 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';
import Aside from './Aside';

export default function Article({
  asideTitle,
  title,
  lastUpdated,
  anchorTagText,
  asideBody,
  children
}) {
  return (
    <div className={styles.container}>
      <article className={styles.article}>
        <H2Alt tag="h1" marginClass={margin.bottom_md}>
          {title}
        </H2Alt>
        {!!lastUpdated && (
          <SecondaryH6 uppercase tag="div" marginClass={margin.bottom_md}>
            Last Updated {lastUpdated}
          </SecondaryH6>
        )}
        {children}
      </article>
      <Aside
        asideTitle={asideTitle}
        anchorTagText={anchorTagText}
        asideBody={asideBody}
      />
    </div>
  );
}
